// extracted by mini-css-extract-plugin
export default {"supportTickets":"styles_supportTickets__iI4bp","loading":"styles_loading__gN8w4"};